
export default class UtilisateurDto {
  id;
  username;
  nom;
  prenom;
  email;
  password;
  lastLogin;
  createdDate;
  roles = [];
  marches = [];
  lastLogin;
  statutUtilisateur;
}